
<div class="theme-color" :style="{backgroundColor: color}" @click="toggle">
  <a-icon v-if="sChecked" type="check" />
</div>
